import { render, staticRenderFns } from "./topics.vue?vue&type=template&id=1ff82e82&"
import script from "./topics.vue?vue&type=script&lang=js&"
export * from "./topics.vue?vue&type=script&lang=js&"
import style0 from "./topics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./topics.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports